import { render, staticRenderFns } from "./UserDropdownButtons.vue?vue&type=template&id=fe437336&scoped=true&"
import script from "./UserDropdownButtons.vue?vue&type=script&lang=js&"
export * from "./UserDropdownButtons.vue?vue&type=script&lang=js&"
import style0 from "./UserDropdownButtons.vue?vue&type=style&index=0&id=fe437336&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe437336",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/dostartu.pl/app.startzone.online/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fe437336')) {
      api.createRecord('fe437336', component.options)
    } else {
      api.reload('fe437336', component.options)
    }
    module.hot.accept("./UserDropdownButtons.vue?vue&type=template&id=fe437336&scoped=true&", function () {
      api.rerender('fe437336', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/UserDropdownButtons.vue"
export default component.exports